import styled from 'styled-components';
import Card from '../../../../components/Card';
import Select from '../../../../components/Select/SelectFilter';
import RadioButtons from '../../../../components/RadioButtons';
import RadioSwitch from '../../../../components/RadioSwitch';
import Input from '../../../../components/Input';
import { I18n } from 'react-redux-i18n';
import Button from '../../../../components/Button';
import { Link } from 'react-router-dom';

const DistributionFiltersContainer = styled.div`
  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    width: 100%;
  }

  .selectTopRow {
    flex-basis: 31%;
    margin-right: 20px;
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    > div {
      padding: 0;
      height: auto;
    }

    .row {
      flex-direction: column;
      align-items: center;
    }

    .row > div {
      margin-left: 20px;
      margin-top: 10px;
      min-width: 200px;
    }
  }

  .distributionFiltersContainer {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 25px;
    width: 100%;

    > * {
      align-self: flex-start;
    }
    .label {
      margin-bottom: 15px;
    }
  }

  .goToTravel {
    align-self: flex-end;
    text-decoration: none;

    > div {
      width: 100%;
    }
  }
`;

const DistributionFilters = ({
  radioButtonsProps,
  marketFilter,
  wineFilter,
  yearFilter,
  competitorsFilter,
  USCampaignFilter,
  changeInputValueMarket,
  inputValueMarket,
  currentCampaign,
  marketPresentationPdf
}) => {
  const downloadMarketPresentation = () => {
    if (marketPresentationPdf) {
      const link = document.createElement('a');
      link.setAttribute('target', '_blank');
      link.setAttribute('href', marketPresentationPdf);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <DistributionFiltersContainer>
      <Card>
        <div className="distributionFiltersContainer">
          <Select
            {...marketFilter}
            onInputChange={(value) => changeInputValueMarket(value)}
            filterOption={(props) =>
              inputValueMarket
                ? props.data.name.match(new RegExp(inputValueMarket, 'gi'))
                : true
            }
          />

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '15px',
              width: '100%'
            }}
          >
            {!USCampaignFilter.disabledSwitch && (
              <div style={{ flex: '1', textAlign: 'left' }}>
                <RadioSwitch {...USCampaignFilter} />
              </div>
            )}
            <div style={{ flex: '1', textAlign: 'left' }}>
              <RadioButtons {...radioButtonsProps} />
            </div>
          </div>

          <Select placeholder="2019" {...yearFilter} />
          <Select isMulti {...wineFilter} />
          <Input
            type="modal"
            label={I18n.t('rivalsMaj')}
            {...competitorsFilter}
          />
          <div
            style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
          >
            <Link
              className="goToTravel"
              style={{ width: '100%' }}
              to={`/travel${
                currentCampaign && currentCampaign.market
                  ? '/?market_id=' + currentCampaign.market.id
                  : ''
              }`}
            >
              <Button
                label={I18n.t('goToTravel')}
                iconLeft
                icon="showLocalisation"
                fontFamily="SFCompactText"
                height="32px"
                textTransform="normal"
                borderRadius="24px"
                fontSize="12px"
                width="100%"
              />
            </Link>
            <Button
              label={I18n.t('yourMarketPresentation')}
              iconLeft
              icon="download"
              fontFamily="SFCompactText"
              height="32px"
              textTransform="normal"
              borderRadius="24px"
              fontSize="12px"
              width="100%"
              disabled={!marketPresentationPdf}
              color={marketPresentationPdf ? undefined : 'grey'}
              onClick={downloadMarketPresentation}
            />
          </div>
        </div>
      </Card>
    </DistributionFiltersContainer>
  );
};

export default DistributionFilters;
